export default __webpack_public_path__ + "assets/images/e2f8627f2fb2c38f035ecd2240f587d4.png";